module.exports = __webpack_public_path__ + "img/alert-success.70b42a14.svg";